export default __webpack_public_path__ + "static/media/IMG_5323.20ce5482.PNG";